import { render, staticRenderFns } from "./SuccessProp.vue?vue&type=template&id=15cd864a&"
import script from "./SuccessProp.vue?vue&type=script&lang=js&"
export * from "./SuccessProp.vue?vue&type=script&lang=js&"
import style0 from "./SuccessProp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports